import { render, staticRenderFns } from "./SentNotificationsTable.vue?vue&type=template&id=2e6627cc&"
import script from "./SentNotificationsTable.vue?vue&type=script&lang=js&"
export * from "./SentNotificationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports